import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md font-semibold ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:w-4 [&_svg]:h-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "active:scale-[97%] bg-primary text-primary-foreground hover:bg-primary-hover shadow-[0_1px_1px_0_rgba(0,0,0,0.04),0_3px_6px_-2px_rgba(0,0,0,0.02),0_0_0_1px_rgba(0,0,0,0.16)_inset,0_0_0_2px_rgba(255,255,255,0.16)_inset]",
        destructive:
          "bg-destructive text-background hover:bg-destructive/90",
        secondary:
          "[&_svg]:text-foreground/80 bg-background text-foreground border hover:bg-muted shadow-[0_1px_1px_0_rgba(0,0,0,0.04),0_3px_6px_-2px_rgba(0,0,0,0.02)]",
        ghost: "hover:bg-muted !text-muted-foreground/80",
        link: "text-primary underline-offset-4 hover:underline !px-0",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "text-sm h-9 rounded-md px-2",
        lg: "h-10 rounded-md px-3 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
